var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 7.99953C12.5525 7.99953 13.0002 8.44724 13.0002 8.99953V10.9995C13.0002 11.5518 12.5525 11.9995 12.0002 11.9995C11.4479 11.9995 11.0002 11.5518 11.0002 10.9995V8.99953C11.0002 8.44724 11.4479 7.99953 12.0002 7.99953Z",
    fill: "#EA3838"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37052 3.50583C9.90029 2.5565 10.9025 1.96777 11.9902 1.96777C13.0779 1.96777 14.0801 2.55649 14.6099 3.50581L21.7054 15.7481C21.7289 15.7887 21.7496 15.831 21.7672 15.8745C22.1399 16.7958 22.0322 17.8419 21.4795 18.6679C20.9269 19.4938 20.001 19.9925 19.0072 19.9995L19.0002 19.9995H5.0002C4.98192 19.9995 4.96376 19.999 4.94572 19.9981C4.91047 20 4.87476 20.0001 4.83871 19.9982C3.86902 19.9482 2.98349 19.432 2.46219 18.6128C1.94089 17.7936 1.84831 16.7728 2.21371 15.8732C2.23121 15.8301 2.2517 15.7883 2.27501 15.7481L9.37052 3.50583ZM4.94495 18.001C4.96324 18 4.98166 17.9995 5.0002 17.9995H18.9961C19.3263 17.9962 19.6336 17.8302 19.8173 17.5557C19.9906 17.2966 20.0327 16.9726 19.9335 16.6794L12.875 4.50098L12.8652 4.48365C12.6891 4.16533 12.354 3.96777 11.9902 3.96777C11.6264 3.96777 11.2913 4.16533 11.1152 4.48365L11.1054 4.50098L4.04645 16.6801C3.94909 16.9662 3.98615 17.2823 4.14951 17.5391C4.32328 17.8121 4.61845 17.9842 4.94169 18.0009L4.94495 18.001Z",
    fill: "#EA3838"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14.9995C11 14.4473 11.4478 13.9995 12 13.9995H12.01C12.5623 13.9995 13.01 14.4473 13.01 14.9995C13.01 15.5518 12.5623 15.9995 12.01 15.9995H12C11.4478 15.9995 11 15.5518 11 14.9995Z",
    fill: "#EA3838"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alertIcon.caae278dd7db199e838209988e247828.svg";
export { ForwardRef as ReactComponent };